 <!--
    2019-2-13, AJK, created file
    2019-3-6, AJK, added ability to reset password
    2019-3-6, AJK, updated to use snotify
 -->

<template>
  <div class="login-page container">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <div class="columns is-centered">
      <div id="card" class="column card-container is-full">
        <h1 class="title">Cart</h1>

        <div v-if="!this.cart.products.length">
          <p>There are no items in your cart.</p>
        </div>
        <div class="row is-centered">
            <b-table :data="cart.products" v-if="this.cart.products.length">
              <template slot-scope="props">
            
                <b-table-column field="productName" label="Product">
                  {{ props.row.productName}}
                </b-table-column>        
                
                <b-table-column field="quantity" label="Quantity">
                  <b-field label="">
                      <b-input v-model="props.row.quantity"></b-input>
                  </b-field>
                </b-table-column>        
                
                <b-table-column field="price" label="Price" numeric>
                  {{ props.row.price ? props.row.price : 0 | currency}}
                </b-table-column>
                
                <b-table-column field="extended" label="Extended" numeric>
                  {{ calculateExtended(props.row.quantity, props.row.price) | currency}}
                </b-table-column>

                <b-table-column field="RemoveButton" label=" " numeric>
                    <button v-on:click="removeFromCart(props.row.__kptID)" type="email" placeholder="email" class="button is-primary is-pulled-right">Remove</button>
                </b-table-column>
              </template>
            </b-table>
            <br>
            <div class="flexBox">
              <div class="flexChild flexBox">
                  <router-link class="button is-primary buttonBarChild" :to="{name: 'orderRequest'}">Continue Shopping</router-link>
                  <button v-if="this.cart.products.length" v-on:click="checkCart()" type="email" placeholder="email" class="button is-primary buttonBarChild">Proceed to Checkout</button>
              </div>

              <div class=" flexChild is-pulled-right">
                <h1 class="title textAlignRight" v-if="this.cart.products.length">Total: {{total | currency}}</h1>
                <p class="textAlignRight" v-if="cart.products.length"><strong>Please note that this total does not include shipping costs.</strong></p>
              </div>
            </div>

            <span>Want to share your love of Dean’s Beans with the world? <a href="https://docs.google.com/forms/d/e/1FAIpQLSdunoYnfFJ5CnXfGQBB708op3dqTY_qK3tnDZNU3g2YMR5LFA/viewform" target="_blank"><u>Click here to request Marketing Materials!</u></a></span>
        </div>
        <br>

      </div>
    </div>
  </div>
</template>

<script>
import Confirmation from '@/components/Confirmation'
import loginAPI from '@/api/LoginAPI.js'
import sharedAPI from '@/api/SharedAPI.js'
import store from '../store.js'
import { mapMutations, mapState } from 'vuex'
import axios from 'axios'
import { stringify } from 'querystring';

export default {
    components: {
      'confirmation-component': Confirmation
    },
    name: 'Cart',
    props: ['usernameProp'],
    data () {
        return {
            username: null,
            password: null,
            hash: null,
            errorMsg: null,
            isLoading: false,
            isFullPage: true,
            notificationDuration: 4000,
            orders: [],
            defaultCard: null,
        }
    },

    filters: {
      currency: function(price){
        return "$".concat(price.toFixed(2));
      }
    },

    computed:{
    ...mapState([
      'userInfo','cart'
      ]),

      total: function(){
        var total = 0;
        this.cart.products.forEach(product=>{
            total += product.quantity * product.price
        })
        this.cart.total = total;
        return total;
      }
    },

    created() {
        if( this.usernameProp ){
            this.username = this.usernameProp;
        }
        //Allow email and hash to be passed via query params.
        var hash = this.$route.query.hash;
        var email = this.$route.query.email;
        if( hash !== undefined){
            this.hash = hash;
            this.password = hash;
            this.username = email;
        }

        if(this.$route.params.newCard){
          //if they came from the new CC screen, it will take them back to the modal window.
          this.cardModal(1)
        }
    },
    
    methods: {
        ...mapMutations([
          'setCampaigns', 
          'setEmails',
          'setCampaignsAndEmails',
          'setSelectedCampaign',
          'setCart'
        ]),

        checkCart: function(){
          var self = this
          var notOK = 0
          var inelligibleProducts = []
          for (var i = 0; i < self.cart.products.length; i++){
            if (self.cart.products[i].quantity < 1 || self.cart.products[i].quantity == undefined){
              notOK++
              inelligibleProducts.push(self.cart.products[i].productName)
            }
          }
          if (notOK > 0) {
            self.$root.$children[0].$refs.toast.error("Products in cart can't have a quantity less than 1.", "Error");
          }else{
            self.cardModal(2)
          }
        },

        removeFromCart: function(key){
          var self = this;
          var arrayPosition = self.cart.products.findIndex(product=>product.__kptID == key);
          console.log(arrayPosition)
          self.cart.products.splice(arrayPosition, 1)
          self.setCart(self.cart)
        },

        calculateExtended: function(qty, price){
            var cleanQty = qty ? qty : 0
            var cleanPrice = price ? price: 0
            return cleanQty * cleanPrice;
        },


        cardModal(panel){
          this.cart.isDefaultSetting = false
          var defaultCard = {
            defaultCardID: this.$route.params.creditCardID ? this.$route.params.creditCardID : ''
          }
          this.$buefy.modal.open({
            props: {defaultCard, panel},
            parent: this,
            component: Confirmation,
            hasModalCard: true,
            canCancel: false,
          })
        },
        
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .textAlignRight{
    text-align: end;
    margin-bottom: 5px;
  }

  .flexBox{
    display: flex;
  }

  .flexChild{
    flex: 1;
  }

  .buttonBarChild{
    flex: 0.15;
    margin-right: 5px;
  }

  .has-text-danger {
    padding-bottom: 20px;
  }
  .center {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .card-container {
    padding: 2rem;
    margin: 0px 20px 20px 20px;
  } 
  /*.field-container {*/
  /*  background-color: #FFFFFF;*/
  /*  border: solid 1px #cccccc;*/
  /*  border-radius: 5px;*/
  /*  padding: 2rem;*/
  /*  margin: 0px 20px 20px 20px;*/
  /*}  */
</style>
